// i18n
// import 'src/locales/i18n';

// swr
// import { SWRConfig } from 'swr';

import { I18nProvider } from 'src/locales/i18n-provider';

// scrollbar
import 'simplebar-react/dist/simplebar.min.css';

// lightbox
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

// map
import 'mapbox-gl/dist/mapbox-gl.css';

// carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// image
import 'react-lazy-load-image-component/src/effects/blur.css';

// import { themeConfig } from 'src/theme/theme-config';

// ----------------------------------------------------------------------

// routes
import Router from 'src/routes/sections';
// theme
import { ThemeProvider, themeConfig } from 'src/theme';
// locales
import { LocalizationProvider } from 'src/locales';
// hooks
import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
// components
import { ProgressBar } from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
// import SnackbarProvider from 'src/components/snackbar/snackbar-provider';
// import { SettingsProvider, SettingsDrawer } from 'src/components/settings';
import { SettingsDrawer, defaultSettings, SettingsProvider } from 'src/components/settings';
import SnackbarProvider from 'src/components/snackbar/snackbar-provider';

// auth
// import { AuthProvider, AuthConsumer } from 'src/auth/context/jwt';
import { AuthProvider, AuthConsumer } from 'src/auth/context/firebase';
// utils
import { useLocation } from 'react-router-dom';
import { SnackbarUtilsConfigurator } from './utils/snackbar-utils-configurator';

// ----------------------------------------------------------------------

export default function App() {
  useScrollToTop();
  const location = useLocation();

  // Example: remove banner only for '/public/product-pdf-preview'"
  const hideBanner = [
    '/public/product-pdf-preview',
    '/pdf/listino-aggiornato',
    '/excise-report',
  ].includes(location.pathname);

  return (
    <I18nProvider>
      <AuthProvider>
        <SettingsProvider defaultSettings={defaultSettings}>
          <LocalizationProvider>
            <ThemeProvider
              modeStorageKey={themeConfig.modeStorageKey}
              defaultMode={themeConfig.defaultMode}
            >
              <MotionLazy hideBanner={hideBanner}>
                <SnackbarProvider>
                  <SnackbarUtilsConfigurator />
                  <ProgressBar />
                  <SettingsDrawer defaultSettings={defaultSettings} />
                  <AuthConsumer>
                    <Router />
                  </AuthConsumer>
                </SnackbarProvider>
              </MotionLazy>
            </ThemeProvider>
          </LocalizationProvider>
        </SettingsProvider>
      </AuthProvider>
    </I18nProvider>
  );
}
